var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnderConstruction = function SvgUnderConstruction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66.002,
    height: 66.002,
    viewBox: "0 0 66.002 66.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-under-construction-1636965",
    transform: "translate(-87.5 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4497",
    "data-name": "Caminho 4497",
    d: "M413.45,53.6a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1",
    transform: "translate(-283.049 -30.6)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4498",
    "data-name": "Caminho 4498",
    d: "M448.45,53.6a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1",
    transform: "translate(-313.649 -30.6)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4499",
    "data-name": "Caminho 4499",
    d: "M483.45,53.6a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1",
    transform: "translate(-344.249 -30.6)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4500",
    "data-name": "Caminho 4500",
    d: "M113.9,72.5H89.7v-44h50.6v16.28l2.2,7.92V17.5h-55V74.7h25.741Zm26.4-52.8v6.6H89.7V19.7Z",
    transform: "translate(0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4501",
    "data-name": "Caminho 4501",
    d: "M295.006,205.855h-3.08l-9.79-35.53a5.513,5.513,0,0,0-5.28-4.07h-1.1a5.513,5.513,0,0,0-5.28,4.07l-9.79,35.53h-3.08a3.85,3.85,0,1,0,0,7.7h37.4a3.85,3.85,0,1,0,0-7.7Zm-8.36-11H265.965l3.63-13.2h13.42Zm-14.08-23.981a3.4,3.4,0,0,1,3.19-2.42h1.1a3.4,3.4,0,0,1,3.19,2.42l2.42,8.58h-12.32Zm-7.26,26.181h22l2.42,8.8H262.885Zm29.7,14.3h-37.4a1.65,1.65,0,0,1,0-3.3h37.4a1.65,1.65,0,1,1,0,3.3Z",
    transform: "translate(-145.354 -130.054)",
    fill: "#4b4b4b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnderConstruction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/under-construction.477e6e5e.svg";
export { ForwardRef as ReactComponent };